import { Close } from '@mui/icons-material';
import { IconButton, InputAdornment, Tooltip } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectProps } from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

interface IOption {
  id?: string | number | undefined;
  disabled?: boolean;
  name?: React.ReactNode | string | number;
}

export interface SelectCustomProps
  extends Omit<SelectProps, 'defaultValue' | 'value' | 'onChange' | 'ref'> {
  label?: React.ReactNode;
  options?: any[];
  placeholder?: string;
  value?: any;
  onChange?: (val: any) => void;
}

const SelectCustom = (props: SelectCustomProps, _ref) => {
  const { label, required, options, placeholder, error, value, onChange, multiple, name, ...rest } =
    props;

  const handleChange = (valueSelect: any) => {
    if (!onChange) {
      return;
    }

    onChange(valueSelect);
  };

  return (
    <Select
      value={value || ''}
      multiple={multiple}
      onChange={(event) => handleChange(event.target.value)}
      fullWidth
      variant="outlined"
      size="medium"
      displayEmpty
      placeholder={placeholder}
      endAdornment={
        <>
          {value && (
            <InputAdornment position="end" sx={{ position: 'absolute', right: 16 }}>
              <Tooltip title={<FormattedMessage id="map.clearValue" />}>
                <IconButton size="small" onClick={() => handleChange('')} className="clear-btn">
                  <Close fontSize="small" />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          )}
        </>
      }
      {...rest}
    >
      {placeholder && (
        <MenuItem value={''} disabled={true} style={{ opacity: '.5' }}>
          <Typography variant="inherit" style={{ opacity: '.5' }} component="span">
            {placeholder}
          </Typography>
        </MenuItem>
      )}

      {Array.isArray(options) &&
        options?.map((option: IOption, index: number) => {
          const { name, disabled, id, ...rest } = option;
          return (
            <MenuItem key={index} value={id} disabled={disabled} {...rest}>
              {name}
            </MenuItem>
          );
        })}
    </Select>
  );
};

export default SelectCustom;
